import { Component, Input } from '@angular/core';
import { Product } from '@models/models';

@Component({
	selector: 'product-details-modal',
	template: require('./product-details-modal.component.html'),
	styles: [require('./product-details-modal.component.scss')]
})
export class ProductDetailsModalComponent {
	@Input() product: Product;

	constructor() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/quotes/modals/product-details-modal/product-details-modal.component.ts